export default "__VITE_ASSET__DKK4Wuyy__"